import isEqual from 'lodash/isEqual'
import { computed } from 'vue'
import { useStore } from 'vuex'

export default function useCheckHelpers() {
  const commsStore = useStore()

  const storeLedgerId = computed(() => commsStore.state.ledgerId)

  const participantsByChecklist = computed(() => {
    return commsStore.getters.participantsByChecklist
  })

  function checkCheckedByAllParticipants(check) {
    // Checkin ids indicate the number of checkins by participants.
    return isEqual(
      check.checkinIds.length,
      participantsByChecklist.value?.[storeLedgerId.value || this.ledgerId]?.[
        check.checkListId
      ] || 0
    )
  }

  return {
    checkCheckedByAllParticipants,
  }
}
